export default {
  main: {
    site_id: 18751727,
    title: "Terminal PRO Demo",
    showBetBuilderSection: true,
    terminalId: 26737,
    unfocusForInactivity: false,
    disableCheckTicketAfterLogin: true,
    needAdminForResetPin: false,
    ticketAvailableViewMode: ["card"],
    enableTicketAutoCashoutAmountUpdate: false,
    enableTicketPopupFlow: true,
    enableKeyboardCatching: true,
    enableTicketTimer: true,
    disableCashoutAfterLogin: true,
    timeFormat: "HH:mm",
    restrictedAdminPrintableTicketsCount: 5,
    hasDayFilter: true,
    enableHeaderAdminSection: true,
    signInType: "email",
    homeMediaSlides: [
      {
        type: "sport",
        path: "betting/prematch",
      },
    ],
    staffPassword: "0",
    websitePasswordHash: "577dcb414d9955f270bb6fc6c1296d7ccf12a0d1fd3c81871115bcf2be9ed1f0",
    logoSize: "huge",
    termsAndConditions: false,
    enableGameInfo: true,
    showEventTypeFilter: true,
    cashoutCommissionPercent: 4,
    resultPageVirtualsId: [150, 197, 209, 118, 54, 55, 31, 184, 181],
    rfidPinCode: true,
    enableSportListScroll: false,
    showTicketAfterPay: 10000,
    popupForTerminalLock: false,
    mandatoryCasinoLogin: false,
    availableLanguages: {
      "@replace": true,
      spa: {
        short: "ES",
        name: "Esp",
        region: "UnitedKingdom",
        order: 2,
      },
      eng: {
        short: "EN",
        name: "Eng",
        region: "UnitedKingdom",
        order: 1,
      },
      fra: {
        short: "FR",
        name: "Fra",
        order: 14,
      },
      chi: {
        short: "CH",
        name: "Chi",
        order: 9,
      },
    },
  },
  wheelConfig: {
    enableWheel: true,
    isLoggedIn: true,
    spinRotationCount: 4,
    minSelectionsCount: 3,
    minSelectionOdd: 1.5,
    minOdd: 3.3,
    wheelBoosts: [
      {
        name: "Profit Boost",
        value: 10,
      },
      {
        name: "Profit Boost",
        value: 25,
      },
      {
        name: "Profit Boost",
        value: 20,
      },
      {
        name: "Profit Boost",
        value: 15,
      },
      {
        name: "Profit Boost",
        value: 35,
      },
    ],
  },
  historyTabConfig: [
    {
      icon: "sports-section",
      title: "Sport",
    },
    {
      icon: "terminal-deposit-success",
      title: "Withdrawal",
    },
  ],
  betslip: {
    betDetailsOrder: ["total_odd", "stake_without_tax", "total_stake", "min_possible_win", "profit_boost", "estimated_return"] ,
  },
  rfid: {
    logoutIfIdleSecondsCount: 0,
  },
  sportsbook: {
    enableBoostedOdds: false,
    enablePredefinedMultiples: false,
  },
  userSection: {
    sections: ["betHistory"],
  },
  lastTicketButtons: [
    {
      name: "Bet tickets",
      type: "betTicket",
      hideOnRestrictMode: false,
    },
  ],
  routes: [
    {
      url: "betting/live",
      name: "Live",
      enabled: true,
    },
     {
      url: "betting/prematch/all",
      name: "Prematch",
      type: "sportsBook",
      enabled: true,
      nestedItems: [
        {
          url: 'betting/prematch/all',
          type: 'prematch',
          name: 'All Matches',
          enabled: true,
          icon: 'casino-categories-Sportsbook',
        },
        {
          url: 'betting/prematch/betBuilder',
          type: 'betBuilder',
          name: 'Bet Builder',
          enabled: true,
          icon: 'bet-builder',
        },
        {
          url: 'betting/prematch/outrights',
          name: 'Outrights',
          type: 'outrights',
          enabled: true,
          icon: '',
        },
        {
          url: 'betting/prematch/popular',
          type: 'popular',
          name: 'Popular',
          enabled: true,
          icon: 'casino-categories-PopularGames',
        },
      ],
    },

    {
      url: "casino",
      name: "Casino",
      disableByDefault: true,
      enabled: true,
    },
    {
      url: "liveCasino",
      name: "Live Casino",
      disableByDefault: true,
      enabled: true,
    },
    {
      url: "results",
      name: "Results",
      enabled: true,
    },
    {
      url: "tickets",
      name: "Tickets",
      enabled: true,
    },
  ],
  defaultTerminalParams: { pid: 18751727, tid: 26737, token: "ed3cCQ==", currency: "MXN" },
};
